import React, { useState, memo, useEffect } from 'react';
import { ImageUploaderItem } from '@redlink/components/molecules';
import { useMutation, uploadQuery } from '@redlink/services';

export const TemporaryUploader = memo(({ onUpload, onFailure, file }) => {
  const [progress, setProgress] = useState(0);

  const [upload] = useMutation(uploadQuery, {
    done: async ({ Upload: { id, thumbnailUrl } }) => {
      onUpload && onUpload(file, { id, thumbnailUrl });
    },
    failed: () => {
      onFailure && onFailure(file);
    },
    context: {
      fetchOptions: {
        useUpload: true,
        onProgress: (ev) => {
          setProgress((ev.loaded / ev.total) * 100);
        },
        onAbortPossible: () => {},
      },
    },
  });

  useEffect(() => {
    upload({ file });
  }, []);

  return (
    <ImageUploaderItem
      status={ImageUploaderItem.status.busy}
      {...{ progress }}
      text={file.name}
    />
  );
});
